import React from 'react';
import '../css/ImageModal.css'; // Ensure the CSS is applied

const ImageModal = ({ src, onClose }) => {
  return (
    <div className="image-modal" onClick={onClose}>
      <div className="image-modal-content">
        <img src={src} alt="Full-size preview" />
      </div>
      <div className="image-modal-close" onClick={onClose}>
        &times; {/* Close icon */}
      </div>
    </div>
  );
};

export default ImageModal;
